import { useEffect, useState } from 'react'
import axios from 'axios';
import IconClock from '../../components/icons/IconClock';
import IconCoins from '../../components/icons/IconCoins';
import IconCycled from '../../components/icons/IconCycled';
import IconStudent from '../../components/icons/IconSudent';
import IconGoogleCalendar from '../../components/icons/IconGoogleCalendar';
import language from '../../variables/language';

// A lesson is "past" once its start time has already passed today (or any
// earlier day); "live" while today and not yet past; otherwise upcoming -
// same three-way distinction the old inline-styled version had (today>date,
// or today===date && currentHour>startHour), just computed once and named
// instead of re-derived inline in the JSX/CSS.
const lessonStatus = (date, start, todayStr) => {
   if (date < todayStr) return 'past';
   if (date > todayStr) return 'upcoming';
   const [startHour, startMinute] = (start || '0:0').split(':').map(Number);
   const now = new Date();
   const nowMinutes = now.getHours() * 60 + now.getMinutes();
   return (startHour * 60 + (startMinute || 0)) <= nowMinutes ? 'past' : 'live';
};

export default function LessonCard({ item, today, index, onOpen, leaving }) {
   const [participants, setParticipants] = useState([]);
   const lang = language[language.lang];

   useEffect(() => {
      axios.get('/api/events?lesson=' + item.id, { withCredentials: true })
         .then(response => setParticipants(Array.isArray(response.data) ? response.data : []))
         .catch(() => setParticipants([]));
   }, [item.id]);

   const status = lessonStatus(item.date, item.start, today);

   // same "to pay" formula the old card used: (price/60 * duration) once
   // per participant that has a real toPay value (0 or 1, never null) -
   // preserved exactly, just no longer buried in an inline style attribute.
   const payableCount = participants.filter(p => p.toPay === 1 || p.toPay === 0).length;
   const toPay = ((item.price / 60) * item.duration) * payableCount;

   return (
      <div className={'schedule-lesson-card status-' + status + (leaving ? ' leaving' : '')}
         style={{ animationDelay: leaving ? '0ms' : Math.min(index * 35, 280) + 'ms' }}
         onClick={() => onOpen(item.id)}>
         {item.googleEventHtmlLink ? (
            <a className='schedule-lesson-gcal-badge' href={item.googleEventHtmlLink} target='_blank' rel='noreferrer' onClick={e => e.stopPropagation()}>
               <IconGoogleCalendar />
            </a>
         ) : ''}
         <div className='schedule-lesson-top'>
            <span className='schedule-lesson-time'>
               <IconClock style={{ fill: 'currentColor' }} />{item.start}–{item.end}
               {item.isCycled === 1 ? <IconCycled fillColor='icon-red' title={lang.cycledLesson} /> : ''}
            </span>
         </div>

         {item.course ? <div className='schedule-lesson-course'>{item.course}</div> : ''}

         <div className='schedule-lesson-participants'>
            {participants.length === 0 ? (
               <span className='schedule-lesson-participants-empty'>{lang.noParticipantsShort}</span>
            ) : participants.map(p => (
               <span className={'schedule-participant-chip att-' + p.attendence} key={p.id}>
                  <IconStudent />
                  {p.student ? p.student.surname + ' ' + (p.student.name || '').charAt(0) + '.' : '?'}
               </span>
            ))}
         </div>

         <div className='schedule-lesson-bottom'>
            <span className='schedule-lesson-price'><IconCoins style={{ verticalAlign: -2, marginRight: 3, color: '#e5b93a' }} />{item.price} zł/h</span>
            <span className='schedule-lesson-duration'>{item.duration} {lang.min}</span>
            <span className='schedule-lesson-topay'>{toPay.toFixed(0)} zł</span>
         </div>
      </div>
   )
}
